import { Zone } from '../models/zone.model';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';

class ZoneService extends GenericService<Zone, ListItem> {
  constructor() {
    super('/api/Zones');
  }
}

export const zoneService = new ZoneService();